import { createContext, PropsWithChildren, ReactElement } from "react";
import { IAddon } from "./types";
import { addonsStore } from "./store";

export const AddOnsCatalogContext = createContext<IAddon[]>([]);

export function AddonsProvider({ children }: PropsWithChildren): ReactElement {
  const { isLoading, error, data: addons } = addonsStore.useGetAddOns();
  if (isLoading || error || !addons) {
    return <></>;
  }

  return (
    <AddOnsCatalogContext.Provider value={addons}>
      {children}
    </AddOnsCatalogContext.Provider>
  );
}
